/**
 * Currency Module - Type Definitions
 *
 * Shared types for the centralized monetary formatting system.
 * All API monetary values arrive in cents (smallest currency unit).
 */

/** Options for display formatting */
export interface FormatOptions {
  /** ISO 4217 currency code (default: 'USD') */
  currency?: string;
  /** BCP 47 locale tag (default: 'en-US') */
  locale?: string;
  /** Use compact notation: $2.5K, $1.2M (default: false) */
  compact?: boolean;
  /** Omit .00 for whole amounts: $50 instead of $50.00 (default: true) */
  smartDecimals?: boolean;
}

/**
 * Currency configuration for zero-decimal currencies.
 * Most currencies use 2 decimal places (100 cents = 1 unit).
 * Some currencies like JPY use 0 decimal places (1 yen = 1 yen).
 */
export interface CurrencyConfig {
  readonly code: string;
  readonly decimals: number;
}

/** Zero-decimal currencies where 1 unit = 1 smallest unit (no subdivision) */
export const ZERO_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
]);
